import { Box, IconButton } from '@mui/material'
import { MyAvatar } from 'components/global'
import { useState } from 'react'

import { ProfileNavigationMenu } from './profile-navigation-menu'

export const ProfileNavigationElements = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const open = Boolean(anchorEl)

  const id = open ? 'simple-popover' : undefined

  return (
    <Box display="flex" alignItems="center">
      <IconButton
        aria-describedby={id}
        onClick={event => setAnchorEl(event.currentTarget)}
      >
        <MyAvatar size={40} />
      </IconButton>

      <ProfileNavigationMenu
        id={id}
        open={open}
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
      />
    </Box>
  )
}
